export const SET_CATEGORY = 'SET_CATEGORY'
export const SET_PARENT_CATEGORY = 'SET_PARENT_CATEGORY'